import {
  call, put, all, select, delay,
} from 'redux-saga/effects';
import { apiGetProProfile, apiGetProPortfolio } from 'services/api/pro';

import { getErrorMessage } from 'utils/filters';

import { Creators as ProCreators } from '../ducks/pro';
import { Creators as UiCreators, growlTypes } from '../ducks/ui';

const fileName = 'sagas/pro';

export function* getProProfile({ payload }) {
  try {
    // yield put(UiCreators.showLoader('PRO'));

    const { profile } = yield call(apiGetProProfile, payload);

    yield all([
      put(ProCreators.getProProfileSuccess(profile)),
      // put(UiCreators.hideLoader('PRO')),
    ]);
  } catch (error) {
    const message = getErrorMessage(error);
    yield all([
      put(UiCreators.growl(message, growlTypes.GROWL_ERROR, { error, method: `${fileName}/getProProfile` })),
      // put(UiCreators.hideLoader('PRO')),
    ]);
  }
}

export function* getProPortfolio({ payload }) {
  try {
    // yield put(UiCreators.showLoader('PRO'));

    const { list } = yield call(apiGetProPortfolio, payload);

    yield all([
      put(ProCreators.getProPortfolioSuccess(list)),
      // put(UiCreators.hideLoader('PRO')),
    ]);
  } catch (error) {
    const message = getErrorMessage(error);
    yield all([
      put(UiCreators.growl(message, growlTypes.GROWL_ERROR, { error, method: `${fileName}/getProProfile` })),
      // put(UiCreators.hideLoader('PRO')),
    ]);
  }
}
